import { call, put, takeEvery } from "redux-saga/effects";
import {
  RequestFailedUpdate,
  RequestLoadingUpdate,
  RequestSuccessfulUpdate,
} from "../../../request";
import { Post } from "../../../api";
import {
  UpdateRetentionReport,
  UpdateRetentionReportRequestState,
} from "./action";
import { TransformReportResponse } from "./transformer";
import moment from "moment";

export function* retentionSaga() {
  yield takeEvery("retention-request-report", fetchReport);
}

function* fetchReport(action: any) {
  try {
    const { filters } = action;
    const formattedFilters = { ...filters };
    Object.keys(filters).forEach((key) => {
      if (
        !filters[key] ||
        (Array.isArray(filters[key]) && filters[key].length === 0)
      ) {
        delete formattedFilters[key];
      }
    });
    yield put(UpdateRetentionReportRequestState(RequestLoadingUpdate));
    // @ts-ignore
    const response = yield call(Post, `/dashboard/retention?by=${action.by}`, {
      from: moment(action.from).format("YYYY-MM-DD"),
      until: moment(action.until).format("YYYY-MM-DD"),
      filters: formattedFilters,
      breakdowns: action.breakdowns,
      periodicity: action.periodicity,
      userFrom: action.userFrom,
      userUntil: action.userUntil,
      coinsFilters: action.coinsFilters || {},
    });
    yield put(UpdateRetentionReport(TransformReportResponse(response)));
    yield put(UpdateRetentionReportRequestState(RequestSuccessfulUpdate));
  } catch (e) {
    yield put(UpdateRetentionReportRequestState(RequestFailedUpdate));
  }
}
